// extracted by mini-css-extract-plugin
export default {"clinica":"SelectClinica_clinica__m+CM0"};